/* eslint-disable relay/unused-fields */
import { graphql } from 'react-relay/legacy.js';

const homepageRootQuery = graphql`
    query homepageRootQuery(
        $isMobile: Boolean!
        $homepageId: String!
        $userId: String!
        $hasUserId: Boolean!
        $fetchInitialHomepage: Boolean!
        $userType: String!
        $abTestList: [String] = []
        $userCountryCode: String!
        $isTrade: Boolean!
        $priceBookName: String!
        $isClient: Boolean!
        $isRemoveShopByTestVariant: Boolean!
        $isRemoveTopHeroBannerTestVariant: Boolean!
        $isEvergreenCollectionsTestVariant: Boolean!
        $isHpSaleModuleVariant: Boolean = false
    ) {
        viewer {
            ...HpSharedLayout_viewer
            homepage(rootId: $homepageId, abTestList: $abTestList) {
                ...getHomePageMetaContent_homepage
                # necessary to throw error & not cache homepage if no modules return
                modules {
                    __id
                }
            }
        }
    }
`;

const homepageVariables = {
    fetchInitialHomepage: true,
    hasRecentlyViewedItems: false,
    isMobile: false,
    homepageId: '',
    userId: '',
    hasUserId: false,
    recentlyViewedItemIds: [],
    userIds: [],
    isClient: false,
    countryCode: '',
    zipCode: '',
    userType: '',
    isTrade: false,
    userCountryCode: '',
    priceBookName: 'DEFAULT',
    isRemoveShopByTestVariant: false,
    isRemoveTopHeroBannerTestVariant: false,
    isEvergreenCollectionsTestVariant: false,
};

export { homepageRootQuery, homepageVariables };
